import type { ReactNode } from "react";
import type { SxProps, Theme } from "@mui/material/styles";
import { ListGridTemplate } from "@/components/list-grid/ListGridTemplate";

const AREAS = `'expand . orderNumber . customer . source . status . orderDate . lastSynced . detail'`;
const COLUMNS = "32px 12px 150px 12px minmax(200px, 1fr) 12px 120px 12px 220px 12px 140px 12px 150px 8px 32px";

interface OrderListTemplateProps {
  children: ReactNode;
  onClick?: () => void;
  sx?: SxProps<Theme>;
}

/** The grid every order list row and its headings are laid out on; cells place themselves by gridArea name. */
export const OrderListTemplate = (props: OrderListTemplateProps) => {
  const { children, onClick, sx } = props;

  return (
    <ListGridTemplate
      areas={AREAS}
      columns={COLUMNS}
      onClick={onClick}
      sx={sx}
    >
      {children}
    </ListGridTemplate>
  );
};
